import { Pipe } from '@angular/core';
import { isString } from '../utils/utils';
var MatchPipe = (function () {
    function MatchPipe() {
    }
    MatchPipe.prototype.transform = function (input, pattern, flag) {
        if (!isString(input)) {
            return input;
        }
        var regexp = pattern instanceof RegExp ? pattern : new RegExp(pattern, flag);
        return input.match(regexp);
    };
    return MatchPipe;
}());
export { MatchPipe };
MatchPipe.decorators = [
    { type: Pipe, args: [{
                name: 'match'
            },] },
];
/** @nocollapse */
MatchPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=match.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-pipes/esm/string/match.pipe.js
// module id = 281
// module chunks = 103